import { cssVarColors } from 'lib/cssSelector'
import { Styles } from 'react-jss'
const { main } = cssVarColors

export const style: Styles = {
  photo: {},
  infoBlock: {},
  photoDark: {},
  infoBlockDark: {},

  profileInfo: {
    paddingBottom: '12px',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    gap: '8px',
    '& > $photo': {
      display: 'block',
      width: 33,
      height: 33,
      border: `2px solid ${main}`,
      borderRadius: '50%',
      '& > img, & > svg': {
        backgroundColor: '#FFFFFF',
        width: 33,
        height: 33,
        borderRadius: '50%'
      }
    },
    '& > $infoBlock': {
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    }
  },

  '@media (max-width: 767px)': {
    hideOnXS: {},
    infoBlock: {
      '&$hideOnXS': {
        display: 'none'
      }
    }
  }
}
